<template>
  <Layout class="home">
    <Header class="header">
      <Row>
        <iCol span="6">
          <h1 class="title">
            LIGO
          </h1>
        </iCol>
        <iCol span="12">
          <Menu
            class="nav"
            mode="horizontal"
            theme="dark"
            active-name="dashboard"
          >
            <MenuItem
              :to="{ name: 'dashboard' }"
              name="dashboard"
            >
              首页
            </MenuItem>
            <MenuItem
              :to="{ name: 'supplier' }"
              name="supplier"
            >
              渠道
            </MenuItem>
            <MenuItem
              :to="{ name: 'media' }"
              name="media"
            >
              媒体
            </MenuItem>
            <MenuItem
              :to="{ name: 'adspot' }"
              name="adspot"
            >
              广告位
            </MenuItem>
          </Menu>
        </iCol>
        <iCol
          span="6"
          style="text-align: right"
        >
          <div class="button-container">
            <Button
              class="log-out"
              type="text"
              :to="{ name: 'login' }"
              ghost
            >
              <Icon
                type="md-log-out"
                :size="18"
              />
            </Button>
          </div>
          <h2
            class="user-name"
            v-text="userName"
          />
        </iCol>
      </Row>
    </Header>
    <Content class="content-wrap">
      <Card class="content">
        <router-view />
      </Card>
    </Content>
    <Footer class="footer" />
  </Layout>
</template>

<script>
import { mapState } from 'vuex'
import { Layout, Header, Content, Footer, Card, Row, Col, Menu, MenuItem, Button, Icon } from 'iview'

export default {
  name: 'Home',

  components: {
    Layout,
    Header,
    Content,
    Footer,
    Card,
    Row,
    iCol: Col,
    Menu,
    MenuItem,
    Button,
    Icon
  },

  computed: {
    ...mapState({
      userName: 'userName'
    })
  }
}
</script>

<style lang="less" scoped>
.home {
  min-height: 100vh;

  .header {
    .title {
      float: left;
      font-size: 40px;
      font-weight: 500;
      letter-spacing: 7px;
      color: #515a6e;
      text-shadow: 3px 1px 0px #fff;
    }
    .nav {
      margin: 2px 0;
    }
    .user-name,
    .button-container {
      float: right;
      margin-left: 10px;
      margin-right: 10px;
      color: #fff;
    }
    .button-container {
      margin: 0;
    }
  }

  .content-wrap {
    padding: 50px 50px 0;

    .content {
      min-height: calc(100vh - 214px);
    }
  }

  .footer {
    text-align: center;
  }
}
</style>
